import type { JSX, ReactNode } from 'react';

/**
 * DIE ABSCHLUSSREIHE EINER MASKE (2.3, Auftrag CRM-82): links der Abbruchweg,
 * rechts die Abschlusshandlungen — der eine Hauptknopf als letzter, also ganz
 * rechts. Weitere Knöpfe des Abschlusses stehen vor ihm.
 *
 * Ohne Abbruchweg bleibt die linke Seite leer; der Abschluss steht trotzdem
 * rechts.
 */
export function Abschlussreihe({
  abbruch,
  children,
}: {
  /** Der Abbruchweg — ein gewöhnlicher `.knopf` (Abbrechen, Schließen, Zurück). */
  readonly abbruch?: ReactNode;
  /** Die Abschlusshandlungen, der Hauptknopf zuletzt. */
  readonly children: ReactNode;
}): JSX.Element {
  return (
    <div className="knopfreihe knopfreihe--abschluss">
      {abbruch ?? <span />}
      <div className="knopfreihe__abschluss">{children}</div>
    </div>
  );
}
